import { Set } from 'immutable'
import { Locales } from 'components/I18n/Constants'
import LocaleConstants from 'constants/LocaleConstants'

/**
* Store containing all the locales currently loaded/polyfilled in the browser
*/
class LocaleStore extends Marty.Store {
  state = Set(Locales.en.key)

  handlers = {
    updateLocales: [LocaleConstants.LOCALE_LOADED]
  }

  rehydrate() {
    // Ignore state from the server
    return Set(Locales.en.key)
  }

  loadLocale() {
    return this.fetch({
      id: 'getLoadedLocales',
      dependsOn: [this.app.stores.OrgSettingsStore.getOrgSettings()],
      locally() {
        const { locale } = this.app.stores.OrgSettingsStore.state
        return this.state.get(locale)
      },
      remotely() {
        const { locale } = this.app.stores.OrgSettingsStore.state
        return this.app.actions.LocaleActions.loadLocale(locale)
      },
    })
  }

  updateLocales(locale) {
    this.state = this.state.add(locale)
  }
}

export default LocaleStore



// WEBPACK FOOTER //
// ./src/scripts/stores/LocaleStore.js